/*  ========================================================================
    # Scripts - Overlay Menu
    ========================================================================  */

import tailwindConfig from '../../../tailwind.config';

/**
 * Script that handles the overlay menu trigger and fixed header behavior.
 */
const OverlayMenu = {
  cfg: {
    body: document.body,
    header: document.getElementById('header-main'),
    overlayToggle: document.querySelector('.c-header__toggle'),
    overlayDesktopMenu: document.querySelector('.c-overlay-menu-desktop'),
    overlayDesktopMenuClose: document.querySelector('.c-overlay-menu-desktop__toggle'),
    overlayMobileMenu: document.querySelector('.c-overlay-menu-mobile'),
    overlayMobileMenuClose: document.querySelector('.c-overlay-menu-mobile__toggle'),
    overlayDesktopMask: document.querySelector('.c-overlay-menu-desktop__mask'),
    metaNavWrapper: document.querySelector('.c-header__meta-nav-wrapper')
  },

  /**
   * Handle Overlay Menu
   */
  handleOverlayMenu() {
    const observer = new IntersectionObserver(elements => {
      elements.forEach(element => {
        // Show toggle button on mobile
        if (window.outerWidth <= parseFloat(tailwindConfig.theme.screens.lg)) {
          this.cfg.overlayToggle?.classList.add('c-header__toggle--show');
          return;
        }

        // Show toggle button on desktop if header is not visible
        if (
          !element.isIntersecting &&
          window.outerWidth > parseFloat(tailwindConfig.theme.screens.lg)
        ) {
          this.cfg.overlayToggle?.classList.add('c-header__toggle--show');
        } else {
          this.cfg.overlayToggle?.classList.remove('c-header__toggle--show');
        }
      });
    });

    // Observe header
    observer.observe(this.cfg.header);

    // Open overlay (desktop/mobile) on toggle click
    this.cfg.overlayToggle?.addEventListener('click', e => {
      e.preventDefault();
      if (window.outerWidth <= parseFloat(tailwindConfig.theme.screens.lg)) {
        this.cfg.overlayMobileMenu?.classList.toggle('c-overlay-menu-mobile--show');
      }

      if (window.outerWidth > parseFloat(tailwindConfig.theme.screens.lg)) {
        this.cfg.overlayDesktopMenu?.classList.toggle('c-overlay-menu-desktop--show');
      }
      this.toggleBodyOverflow();
    });

    // Close dektop overlay on mask click
    this.cfg.overlayDesktopMask?.addEventListener('click', e => {
      e.preventDefault();
      this.cfg.overlayDesktopMenu?.classList.toggle('c-overlay-menu-desktop--show');

      this.toggleBodyOverflow();
    });

    // Close dektop overlay on icon click
    this.cfg.overlayDesktopMenuClose?.addEventListener('click', e => {
      e.preventDefault();
      this.cfg.overlayDesktopMenu?.classList.toggle('c-overlay-menu-desktop--show');

      this.toggleBodyOverflow();
    });

    // Close dektop overlay on icon click
    this.cfg.overlayMobileMenuClose.addEventListener('click', e => {
      e.preventDefault();
      this.cfg.overlayMobileMenu?.classList.toggle('c-overlay-menu-mobile--show');

      this.toggleBodyOverflow();
    });

    if (window.innerWidth < tailwindConfig.theme.screens.lg.replace('px', '')) {
      this.calcMenuTop();
    }

    // Determine the menu position
    window.addEventListener('scroll', () => {
      this.calcMenuTop();
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth < tailwindConfig.theme.screens.lg.replace('px', '')) {
        this.calcMenuTop();
      } else if (window.scrollY - (this.cfg.header.offsetTop + this.cfg.header.offsetHeight) < 0) {
        this.cfg.overlayToggle?.classList.remove('c-header__toggle--show');
        if (this.cfg.overlayToggle !== null) this.cfg.overlayToggle.style.top = null;
      }
    });
  },

  /**
   * Toggle body overflow.
   */
  toggleBodyOverflow() {
    if (this.cfg.body.style.overflow) {
      this.cfg.body.style.overflow = null;
    } else {
      this.cfg.body.style.overflow = 'hidden';
    }
  },

  calcMenuTop() {
    if (window.innerWidth < tailwindConfig.theme.screens.lg.replace('px', '')) {
      this.cfg.overlayToggle?.classList.add('c-header__toggle--show');
      const topMenuToggle = 10;
      const rootPadding = 0;
      const metaBarHeight = this.cfg.metaNavWrapper?.offsetHeight;
      let menuTop;
      if (window.scrollY < metaBarHeight + rootPadding) {
        menuTop = topMenuToggle + rootPadding + metaBarHeight - window.scrollY;
      } else {
        menuTop = 16;
      }
      if (this.cfg.overlayToggle !== null) this.cfg.overlayToggle.style.top = menuTop + 'px';
    } else if (this.cfg.overlayToggle !== null) this.cfg.overlayToggle.style.top = null;
  },

  /**
   * Initialize.
   */
  init() {
    this.handleOverlayMenu();
  }
};

export default OverlayMenu;
